<template>
  <div class="model-2">
	  <div class="editor-wrapper" :style="{backgroundColor:editablePageConfig.editable_page_config_content.back_color}">
	    <div class="html" v-html="editablePageConfig.editable_page_config_content.editor_content"></div>
	  </div>
  </div>
</template>

<script>
export default {
  name: 'Model2',
  data () {
    return {
    }
  },
  props: ['editablePageConfig','editablePage'],
  computed: {

  },
  methods: {

  }
}
</script>

<style lang="scss">
.model-2 .editor-wrapper{
	border-radius: 5px;
}
.model-2 .editor-wrapper .html *{
   max-width: 100%;
}
</style>
